module.exports = __webpack_public_path__ + "static/media/blue-ram-cichlid.156ab34d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/blue-ram-cichlid.png
// module id = 303
// module chunks = 0